export const SCHEMA_NAME = "ServiceTypes";

export const FIELDS = {
  SERVICE_TYPE_ID: "serviceTypeID",
  SERVICE_DOCUMENT_ID: "serviceDocumentID",
  SERVICE_TYPE: "serviceType",
  SERVICE_INSTRUCTIONS: "serviceInstructions",
  DEPUTIZED_AGENCY_NAME: "deputizedAgencyName",
  SERVICE_STATUS: "serviceStatus",
  SERVED_BY_STAFF_ID: "servedByStaffID",
  PERSON_SERVED_JACKET_ID: "personServedJacketID",
  DATE_SERVED: "dateServed",
  TIME_SERVED: "timeServed",
  COMMENTS: "comments",
  SERVED_TO: "servedTo",
  DATE_ADDED: "dateAdded",
  TIME_ADDED: "timeAdded",
  ACTUAL_ADDRESS_ID: "actualAddressID",
  ASSIGNED_TO_STAFF_ID: "assignedToStaffID",
  SERVICE_AREA: "serviceArea",
  ADDRESS_TO_SERVE_ID: "addressToServeID",
};
